import React from 'react';
import ProductPageTemplate from '../../components/ProductPageTemplate';
import { roPlants } from '../../mock/mockData';

const ROPlant4000LPH = () => {
  const productData = roPlants.find(p => p.id === 'ro-4000');
  return <ProductPageTemplate productData={productData} />;
};

export default ROPlant4000LPH;